<ng-container *ngIf="policy$ | async as policy">
  <vs-card class="overflow-hidden">
    <vs-card-header
      [config]="{
      title: 'Cancellation Rules',
      subtitle: 'Review and manage the cancellation rules for this policy.'
    }"
    >
      <button vs-button slot="end" appearance="outline" (click)="openCancelationRuleEditDialog()">
        <vs-icon name="plus"></vs-icon>
        Add new rule
      </button>
    </vs-card-header>

    <ng-container *ngIf="policy?.cancelationRules?.length; else noRules">
      <vs-table
        *ngIf="(policy && policy.cancelationRules) ?? [] as rules"
        [columns]="(columns$ | async) ?? []"
        [data]="rules"
      ></vs-table>
    </ng-container>
    <ng-template #noRules>
      <div class="flex flex-col justify-center gap-2 p-6 mt-4">
        <p class="text-xl font-semibold text-gray-900 self-center">No rules configured.</p>
        <p class="font-normal text-gray-600 self-center mb-4">
          There are currently no rules configured. Add rules to ensure your warranty cancellations respect state
          regulations.
        </p>
      </div>
    </ng-template>
  </vs-card>

  <ws-edit-cancelation-rule-dialog
    *ngIf="policy"
    #editCancelationRuleDialog
    [policy]="policy"
    [policyCancelationRule]="selectedPolicyCancelationRule"
    [takenStates]="policy?.cancelationRules | pluck: 'state'"
  ></ws-edit-cancelation-rule-dialog>
  <vs-dialog #deleteCancelationRuleDialog [config]="{ dialogContainerClass: 'w-[500px] max-w-[800px]' }">
    <vs-dialog-header
      [config]="{
        mode: 'simple',
        showDivider: true,
        
        icon: 'trash-01',
        iconTheme: 'danger',
  
        title: 'Delete Cancellation Rule',
        subtitle: 'Are you sure you want to remove ' + (selectedPolicyCancelationRule?.country + ' - ' + selectedPolicyCancelationRule?.state) + '? This action can not be undone.'
      }"
    ></vs-dialog-header>

    <div class="flex justify-between gap-2 mt-4 mx-4">
      <button vs-button appearance="outline" class="basis-1/2" (click)="deleteCancelationRuleDialog.close()">
        Back
      </button>
      <button
        *ngIf="selectedPolicyCancelationRule"
        vs-button
        theme="danger"
        class="basis-1/2"
        (click)="deleteCancelationRule(selectedPolicyCancelationRule); deleteCancelationRuleDialog.close();"
      >
        Delete Rule
      </button>
    </div>
  </vs-dialog>
</ng-container>
